import { cn } from '@/utils';

/** Shared Figma pill chrome for Global / Rounds / Match / Live filter chips. */
export const LEADERBOARD_FILTER_PILL_BASE = cn(
	"shrink-0 h-6 rounded-[20px] border-[0.5px] border-solid font-['DM_Sans']",
	'text-[12px] font-medium leading-[14px] tracking-[-0.12px]',
	'shadow-[0_2px_10px_rgba(0,0,0,0.06)] transition-colors'
);

/** Solid blue selected tab (tone only — pair with PAD_*). */
export const LEADERBOARD_FILTER_PILL_ACTIVE = 'border-[#81A1F8] bg-[#5583F6] text-white';

/** Resting white chip (tone only — pair with PAD_*). */
export const LEADERBOARD_FILTER_PILL_INACTIVE = 'border-[#E5E5E5] bg-white text-[#474747]';

/** Applied time-range chip (outline + text accent). Figma: border #81A1F8, text #5583F6. */
export const LEADERBOARD_FILTER_PILL_RANGE_ACTIVE = 'border-[#81A1F8] bg-white text-[#5583F6]';

/** Text-only pills (e.g. Global). Figma: px 8. */
export const LEADERBOARD_FILTER_PILL_PAD_PLAIN = 'px-2';

/** Date chip without caret (multi-month compact). Figma: px 10. */
export const LEADERBOARD_FILTER_PILL_PAD_RANGE = 'px-2.5';

/** Dropdown pills with caret. Figma: pl 10 / pr 8 / gap 4. */
export const LEADERBOARD_FILTER_PILL_PAD_CARET = 'flex items-center gap-1 pl-2.5 pr-2';
